import { useState, useEffect, useContext } from "react";
import {
  Container,
  Card,
  Form,
  Button,
  Navbar
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import loginPageImg from "../../components/Assests/Icons/login-page-img.png";
import phibroLogo from "../../components/Assests/Phibro-Tagline-Logo.png";

import { signIn } from "../../services/signInApi";
import { getRole } from "../../services/signInApi";
import InvalidCredentialsModal from "./components/InvalidCredentialsModal";
import "./styles/customerSignIn.css";
import { RoleContext } from "../../RoleContext";


const PhibroSignIn = () => {
  const [email, setEmail] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const { setRole, setRoleOptions } = useContext(RoleContext);

  const navigate = useNavigate();

  useEffect(() => {
    const savedEmail = localStorage.getItem("userEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);
console.log("before signIn");
  const handleSignIn = async () => {
    try {
       console.log(" signIn");
      localStorage.clear();
      const response = await signIn();
      console.log("New", response);
      if (response?.success || response?.token) {
       console.log("Response", response);
        const userData = await getRole(response?.token); //Get the role

        localStorage.setItem("accessToken", response.token);
        localStorage.setItem("userData", JSON.stringify(userData));
        const { roleName, locations } = userData;
        const currentrole =
          localStorage.getItem("currentRole") || roleName[0] || "";
        localStorage.setItem("currentRole", JSON.stringify(currentrole));
          console.log("Response2", roleName[0]==="Analyst");
          console.log("first", locations);
          const locationName = locations.map(ele => ele.locationName).join(",");
          localStorage.setItem("selectedLocationName", JSON.stringify(locationName));  
        console.log("second", locations);
        setRoleOptions(userData.roleName || []);
        setRole(
          userData.roleName && userData.roleName[0]
            ? userData.roleName[0]
            : ""
        );
  console.log("Response", response);
        if (rememberMe) {
          localStorage.setItem("userEmail", email);
        } else {
          localStorage.removeItem("userEmail");
        }

        navigate("/global-dashboard");
      } else {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Login error:", error);
      setShowModal(true);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        backgroundImage: `url(${loginPageImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header with logo and title */}
      <Navbar bg="white" className="px-3" style={{ borderBottom: "4px solid #0070c0", minHeight: 60 }}>
        <Navbar.Brand href="#" className="d-flex align-items-center gap-2">
          <img src={phibroLogo} alt="Phibro Logo" style={{ height: 40 }} />
          <span style={{ fontWeight: 500, fontSize: 22, color: "#003087" }}>Feed Assay Portal</span>
        </Navbar.Brand>
      </Navbar>

      {/* Main Content: Centered card */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Container className="d-flex justify-content-center align-items-center" style={{ background: "transparent" }}>
          <Card className="text-center p-4 shadow-lg rounded-4" style={{ minWidth: 340, maxWidth: 400 }}>
            <Card.Body>
              <Form>
                <Button
                  variant="success"
                  className="signin-btn w-100 mb-3"
                  style={{ borderRadius: 20, fontWeight: 500, fontSize: 18, height: 44 }}
                  onClick={handleSignIn}
                >
                  Sign In
                </Button>
                <Button
                  variant="primary"
                  className="create-account-btn w-100 mb-3"
                  style={{ borderRadius: 20, fontWeight: 500, fontSize: 18, height: 44, background: '#003087', border: 'none' }}
                  onClick={() => navigate("/registrationForm")}
                >
                  Don’t have an Account?
                </Button>
                <Button
                  variant="outline-success"
                  className="create-account-Faq w-100 mb-3"
                  style={{ borderRadius: 20, fontWeight: 500, fontSize: 18, height: 44 }}
                  onClick={() => navigate("/faqs")}
                >
                  FAQs
                </Button>
              </Form>
            </Card.Body>
          </Card>
          <InvalidCredentialsModal
            show={showModal}
            onHide={() => setShowModal(false)}
          />
        </Container>
      </div>

      {/* Footer */}
      <Navbar variant="dark" className="justify-content-center footer-style" style={{ minHeight: 40 }}>
        <span className="text-white" style={{ fontSize: 14 }}>
          © 2025 Phibro Animal Health Corporation. All rights reserved.
        </span>
      </Navbar>
    </div>
  );
};

export default PhibroSignIn;
